<template>
  <div v-if="chat.ticket.lead_id">
    <div class="animated--grow-in border-left p-0-sm pl-0 ml-0">
      <div v-if="false" style="height: 69px;" class="col-12 border-bottom pl-4 m-0 d-flex align-items-center cursor-default">
        <span style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: .8rem;">{{ getTranslations('expression_564') }}</span>
      </div>
      <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" class="pt-0 pb-0 border-bottom">
        <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" class="pr-4 py-2 pl-2">
          <div class="py-4 d-flex align-items-center cursor-default" style="justify-content: center;">
            <div class="avatar_content">
              <div style="width: 80px; height: 80px;"
                   class="pl-2 avatar">
                <img style="min-width: 80px;
                                   min-height: 80px;
                                   z-index: 9;
                                   display: flex;
                                   border-radius: 50%;
                                   align-items: center;
                                   justify-content: center;"
                     class="avatar-img mt-2"
                     :src="(getLeadObject('id', chat.ticket.lead_id).avatar_url
                            ? getLeadObject('id', chat.ticket.lead_id).avatar_url
                            : lead_avatar)"/>
                <span style="min-width: 80px;
                                   min-height: 80px;
                                   margin-left: -80px;
                                   z-index: 8;
                                   display: flex;
                                   border-radius: 50%;
                                   align-items: center;
                                   justify-content: center;
                                   background-color: #eee;"
                      class="avatar-img mt-2">
                  <i class="bx bx-loader-alt bx-spin" style="font-size: 2rem; color: #bfbfbf;"></i>
                </span>
              </div>
            </div>
            <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" class="pl-3">
              <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" class="pt-1">
                <span style="color: #353535; position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 500">
                  {{ getLeadObject('id', chat.ticket.lead_id).name }}
                </span>
              </div>
              <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                <i :class="getChannelObject('id', chat.ticket.channel_id).type ? getChannelObject('id', chat.ticket.channel_id).type.icon : 'bx bx-mobile'"></i>
                <span style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 500">
                  {{ identifierAndIconChannelOfLead(getLeadObject('id', chat.ticket.lead_id))
                      ? identifierAndIconChannelOfLead(getLeadObject('id', chat.ticket.lead_id)).identifier_lead
                      : '---' }}
                  <!-- {{ getLeadObject('id', chat.ticket.lead_id).phone_hidden }} -->
                </span>
              </div>
              <div style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; line-height: .8rem;">
                <span style="font-family: 'Product Sans Light Regular'; position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 400; font-size: .7rem;">
                  {{ getTranslations('expression_164') }} {{ getLeadObject('id', chat.ticket.lead_id).created }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top mt-2" style="margin-left: -18px; margin-right: -22px;">
          <div class="col-12 pt-2">
            <div class="col-12">
              <ul style="justify-content: center;" class="nav nav-pills mb-2" id="pills-tab" role="tablist">
                <li @click.prevent="tab = 1"
                    v-b-tooltip.bottom
                    :title="getTranslations('expression_565')"
                    class="nav-item"
                    role="presentation">
                  <a class="nav-link active"
                     id="pills-profile-tab"
                     data-toggle="pill"
                     href="#pills-profile"
                     role="tab"
                     aria-controls="pills-profile"
                     aria-selected="true">
                    <i style="font-size: 1.2rem; color: blue" class="bx bxs-user"></i>
                  </a>
                </li>
                <li @click.prevent="tab = 2"
                    v-b-tooltip.bottom
                    :title="getTranslations('expression_175')"
                    class="nav-item"
                    role="presentation">
                  <a class="nav-link"
                     id="pills-address-tab"
                     data-toggle="pill"
                     href="#pills-address"
                     role="tab"
                     aria-controls="pills-address"
                     aria-selected="false">
                    <i style="font-size: 1.2rem; color: brown" class="bx bxs-briefcase"></i>
                  </a>
                </li>
                <li @click.prevent="tab = 3; loadLeadTags()"
                    v-b-tooltip.bottom
                    :title="getTranslations('expression_150')"
                    class="nav-item"
                    role="presentation">
                  <a class="nav-link"
                     id="pills-tags-tab"
                     data-toggle="pill"
                     href="#pills-tags"
                     role="tab"
                     aria-controls="pills-tags"
                     aria-selected="false">
                    <i style="font-size: 1.2rem; color:red" class="bx bxs-purchase-tag"></i>
                  </a>
                </li>
                <li @click.prevent="tab = 4; loadLeadNotes()"
                    v-b-tooltip.bottom
                    :title="getTranslations('expression_149')"
                    class="nav-item"
                    role="presentation">
                  <a class="nav-link"
                     id="pills-notes-tab"
                     data-toggle="pill"
                     href="#pills-notes"
                     role="tab"
                     aria-controls="pills-notes"
                     aria-selected="false">
                    <i style="font-size: 1.2rem; color:orange" class="bx bxs-notepad"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--Lead Details-->
      <div id="chat_details" class="card-body pl-3">
        <div class="row">
          <div class="col-12 pt-3 pb-4 px-4">
            <div class="tab-content" id="options_tabs">
              <!-- PROFILE -->
              <div class="tab-pane fade show active"
                   id="pills-profile"
                   role="tabpanel"
                   aria-labelledby="pills-profile-tab">
                <div class="row">
                  <div class="col-12">
                    <label class="mb-0">{{ getTranslations('expression_42') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" class="input_forms form-control"
                             v-model="getLeadObject('id', chat.ticket.lead_id).name">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="mb-0">{{ getTranslations('expression_161') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" class="input_forms form-control"
                             v-model="getLeadObject('id', chat.ticket.lead_id).email">
                    </div>
                  </div>
                  <!--<div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_566') }}</label>
                    <div class="input-group mb-2">
                      <select v-model="getLeadObject('id', chat.ticket.lead_id).genre_key"
                              class="input_forms custom-select">
                        <option :value="2" selected="selected">{{ getTranslations('expression_567') }}</option>
                        <option :value="0">{{ getTranslations('expression_568') }}</option>
                        <option :value="1">{{ getTranslations('expression_569') }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_168') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" class="input_forms form-control"
                             v-model="getLeadObject('id', chat.ticket.lead_id).document">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_174') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" class="input_forms form-control"
                             v-model="getLeadObject('id', chat.ticket.lead_id).office">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_173') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" class="input_forms form-control"
                             v-model="getLeadObject('id', chat.ticket.lead_id).company">
                    </div>
                  </div>-->
                  <div class="col-12 text-center">
                          <span @click.prevent="updateLead(getLeadObject('id', chat.ticket.lead_id))"
                                class="btn btn-outline-primary rounded-0">
                            {{ getTranslations('expression_120') }}
                          </span>
                  </div>
                </div>
              </div>
              <!-- ADDRESS -->
              <div class="tab-pane fade" id="pills-address" role="tabpanel" aria-labelledby="pills-address-tab">
                <div class="row">
                  <div class="col-8">
                    <label class="mb-0">{{ getTranslations('expression_176') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.zip_code"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-4">
                    <label class="mb-0">{{ getTranslations('expression_178') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.number"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="mb-0">{{ getTranslations('expression_175') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.street"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_179') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.district"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_177') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.city"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_180') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.state"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-6">
                    <label class="mb-0">{{ getTranslations('expression_182') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.country"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="mb-0">{{ getTranslations('expression_365') }}</label>
                    <div class="input-group mb-2">
                      <input type="text" v-model="getLeadObject('id', chat.ticket.lead_id).address.reference"
                             class="input_forms form-control">
                    </div>
                  </div>
                  <div class="col-12 text-center">
                          <span @click.prevent="updateLead(getLeadObject('id', chat.ticket.lead_id))"
                                class="btn btn-outline-primary rounded-0">
                            {{ getTranslations('expression_120') }}
                          </span>
                  </div>
                </div>
              </div>
              <!-- TAGS -->
              <div class="tab-pane fade"
                   id="pills-tags"
                   role="tabpanel"
                   aria-labelledby="pills-tags-tab">
                <div class="row pt-2">
                  <!--                      <div class="col-12 pb-4 text-center cursor-default">-->
                  <!--                        <span style="font-weight: 500; font-size: 0.9rem; border: 1px solid #e3e6f0; border-radius: 30px; padding: .4rem 1rem;">Tags Vinculados</span>-->
                  <!--                      </div>-->
                  <div class="col-12 text-center">
                    <div v-if="getTagsArray('channel_id', chat.ticket.channel_id).length === 0"
                         class="col-12 text-center"
                         style="display: contents;">
                      <span>{{ getTranslations('expression_189') }}</span>
                    </div>
                    <div class="col-12 text-center pb-2" style="display: contents;">
                      <div v-for="tag in getTagsArray('channel_id', chat.ticket.channel_id)"
                           :key="tag.id"
                           @click="selectTag(getLeadTagObject('tag_id', tag.id).id, tag.id)"
                           class="chip mr-2 mb-3 cursor_pointer">
                        <div class="chip-body">
                                <span style="font-size: .7rem;" class="chip-text pl-1">
                                  {{ tag.name }}
                                </span>
                          <div class="chip-closeable"
                               :class="getLeadTagObject('tag_id', tag.id).id !== undefined ? 'bg-success' : ''">
                            <i :class="getLeadTagObject('tag_id', tag.id).id !== undefined ? 'bx-check' : 'bx-x'"
                               class="bx "></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- NOTES -->
              <div class="tab-pane fade"
                   id="pills-notes"
                   role="tabpanel"
                   aria-labelledby="pills-notes-tab">
                <div class="row">
                  <div class="col-12 pt-4">
                    <div class="input-group">
                      <div class="input-group-prepend rounded-0">
                        <button type="button"
                                style="display: flex; align-items: center;"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                class=" btn-notes btn inputs_notes secundary-prepend dropdown-toggle">
                          <i :class="getNoteTypeObject('id', note.type_key).icon"
                             class="ml-1 mr-2"></i>
                        </button>
                        <div class="dropdown-menu rounded-0 shadow" style="cursor: pointer;">
                          <div v-for="(type, index) in configs.data.note_types"
                               :key="type.id"
                               @click.prevent="note.type_key = type.id">
                                  <span class="dropdown-item">
                                    <i :class="type.icon" class="fa-fw mr-2 text-gray-400"></i>
                                    {{ type.name }}
                                  </span>
                            <div v-if="index+1 !== configs.data.note_types.length"
                                 class="dropdown-divider"></div>
                          </div>
                        </div>
                      </div>
                      <input name="note"
                             :placeholder="getTranslations('expression_570')"
                             v-model="note.text"
                             rows="1" class=" form-control inputs_notes">
                      <span class="input-group-append">
                              <a @click.prevent="addNote()"
                                 :title="getTranslations('expression_120')"
                                 type="button"
                                 class="px-3 btn-notes btn inputs_notes line-height-2">
                                <i class="fa fa-save mr-1" style="font-size: 14px;"></i>
                              </a>
                            </span>
                    </div>
                  </div>
                  <div v-for="note in notes.pagination.data" :key="note.id"
                       class="col-12 text-center">
                    <div style="border-radius: 20px;" class="card mt-2 shadow-sm">
                      <div class="card-body">
                              <span style="line-height: 1rem; font-size: .9rem; display: block;">
                                {{ note.text }}
                              </span>
                      </div>
                      <div class="cursor-default card-body bg-light border-top py-2">
                              <span v-b-tooltip.bottom
                                    :title="(note.type && note.type.name) ? note.type.name : '---'"
                                    style="line-height: 1rem; display: inline-table;"
                                    class="timer pb-1 px-3">
                                <i style="color: #353535; font-size: .8rem;"
                                   :class="(note.type && note.type.icon) ? note.type.icon : 'bx bxs-note'"
                                   class="mr-2"></i>
                                <span style="color: #353535">{{
                                    getUserObject('id', note.user_id).name ? getUserObject('id', note.user_id).name : '---'
                                  }}</span>
                                <br>
                                <span class="d-block pt-1">{{ note.created }}</span>
                              </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="notes.pagination.total === 0"
                       class="col-12 pt-4 text-center">
                    <span>{{ getTranslations('expression_571') }}</span>
                  </div>
                  <div class="animated--fade-in row text-center pt-4" style="justify-content: center">
                    <Pagination class="mb-3 pt-1"
                                page_item="background-color: #ffffff!important; border-color: #ffffff!important;"
                                page_link="background-color: #ffffff!important; border-color: #ffffff!important;"
                                :items="notes.pagination"
                                commit="SET_NOTES">
                    </Pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import {mapGetters, mapState} from "vuex";
  import lead_avatar from "../../assets/img/no-pic-user.png";
  // import ChatBalloonDefault from "./ChatBalloonDefault";
  import Pagination from "../theme/Pagination";
  
  export default {
    name: "TabInfoContact",
    components: {
      // ChatBalloonDefault,
      Pagination
    },
    data(){
      return {
        lead_avatar: lead_avatar,
        note: {
          type_key: 0,
          text: ''
        },
        tab: 1,
      }
    },
    computed: {
      ...mapState(['chat', 'notes', 'configs', 'me', 'operators']),
      ...mapGetters(['getLeadObject',
        'getChannelObject',
        'getDepartmentObject',
        'getHistoriesArray',
        'getTagsArray',
        'getLeadTagObject',
        'getUserObject',
        'getNoteTypeObject',
        'getInterestsArray',
        'getMotivesArray',
        'getSourcesArray',
        'getRepliesArray',
        'getTranslation',
      ]),
    },
    methods: {
      identifierAndIconChannelOfLead(lead) {
        let channel = this.getChannelObject('id', lead.channel_id);
        let identifier = lead.phone_hidden ? lead.phone_hidden : '---';

        switch (channel.type_key) {
          case 0:
            return {text: 'WhatsApp', icon: 'bx bxl-whatsapp', identifier_lead: identifier};
            break;
          case 1:
            return {text: 'Telegram', icon: 'bx bxl-telegram', identifier_lead: identifier};
            break;
          case 2:
            identifier = lead.username ? `@${lead.username}` : '---';
            return {text: 'Instagram', icon: 'bx bxl-instagram', identifier_lead: identifier};
            break;
          case 3:
            return {text: 'Messenger', icon: 'bx bxl-messenger', identifier_lead: identifier};
            break;
        }

      },
      adjustTextarea(){
        if(this.chat.ui.row_textarea <= 4) {
          this.chat.ui.row_textarea++
        }
      },
      openEmail(){
        this.$root.$emit('openEmail')
      },
      sendMessage() {
        this.text = this.text.trim()
        this.chat.ui.row_textarea = 1
        if(!this.isShowReplies && this.text.length > 0){
          this.$store.dispatch('sendMessage', {
            text: this.text,
            channel_id: this.chat.ticket.channel_id,
            ticket_id: this.chat.ticket.id,
            operator_id: this.isOperator(this.chat.ticket.department_id),
            department_id: this.chat.ticket.department_id,
          })
          this.text = "";
          this.isShowEmoji = false;
        } else {
          this.text = this.text.trim()
        }
      },
      isOperator(department_id) {
        if (department_id === null) {
          department_id = this.getChannelObject('id', this.chat.ticket.channel_id)
        }
        let operator = this.operators.data.find(operator => {
          return operator.department_id === department_id && operator.user_id === this.me.data.id;
        });
        if (operator !== undefined) {
          return operator.id
        } else {
          return null
        }
      },
      showEmoji() {
        if(!this.isShowReplies){
          this.isShowEmoji = !this.isShowEmoji;
          setTimeout(() => {
            document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
          }, 300);
        }
      },
      selectEmoji(a) {
        this.startPosition = this.$refs.chatTextarea.selectionStart;
        this.endPosition = this.$refs.chatTextarea.selectionEnd;
        this.$refs.chatTextarea.setSelectionRange(this.startPosition, this.endPosition);
        const text = this.$refs.chatTextarea.value;
        if(text === null) {
          this.text = a.data
        } else {
          const textBefore = text.substring(0, this.startPosition);
          const textAfter = text.substring(this.endPosition, text.length);
          this.text = `${textBefore}${a.data}${textAfter}`
          this.startPosition += a.data.length;
        }
        setTimeout(() => {
          this.$refs.chatTextarea.setSelectionRange(this.startPosition, this.startPosition);
          this.$refs.chatTextarea.focus()
        }, 100)
      },
      updateLead(payload){
        this.$store.dispatch('updateLead', payload)
      },
      loadLeadTags(){
        this.$store.dispatch('getLeadTags', {lead_id: this.chat.ticket.lead_id})
      },
      selectTag(lead_tag_id, tag_id){
        if(lead_tag_id !== undefined){
          this.$swal.fire({
            title: this.getTranslations('expression_887'),
            text: this.getTranslations('expression_888'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: this.getTranslations('expression_421'),
            cancelButtonText: this.getTranslations('expression_355')
          }).then((result) => {
            if (result.isConfirmed) {
              const lead_tag = {
                lead_id: this.chat.ticket.lead_id,
                id: lead_tag_id
              }
              this.$store.dispatch('deleteLeadTag', lead_tag)
            }
          })
        } else {
          const lead_tag = {
            channel_id: this.chat.ticket.channel_id,
            lead_id: this.chat.ticket.lead_id,
            tag_id: tag_id
          }
          this.$store.dispatch('addLeadTag', lead_tag)
        }
      },
      loadLeadNotes(){
        this.$store.dispatch('getNotes', {lead_id: this.chat.ticket.lead_id})
      },
      addNote(){
        if (this.note.text.length > 0){
          this.note.lead_id = this.chat.ticket.lead_id
          this.$store.dispatch('addNote', this.note)
          this.note.text = ''
        } else {
          this.alertAddNoteError()
        }
      },
      alertAddNoteError(){
        this.$swal.fire({
          position: 'center',
          icon: 'warning',
          title: this.getTranslations('expression_889'),
          showConfirmButton: false,
          timer: 1500
        })
      },
      updateTicket(payload){
        if (payload.negotiation && payload.negotiation.amount) {
          payload.negotiation.amount = parseInt(payload.negotiation.amount.toString().replace(/[^0-9]/g, ''))
        }
  
        this.$store.dispatch('updateTicket', payload)
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      setNegotiation(payload){
        if(this.chat.ticket.negotiation.status_key === payload) {
          this.chat.ticket.negotiation.status_key = 0
        } else {
          this.chat.ticket.negotiation.status_key = payload
        }
  
        this.updateTicket(this.chat.ticket)
      },
      clearTransfer(){
        this.$root.$emit('clearTransfer')
      },
      clearFiles(){
        this.$root.$emit('clearFiles')
      },
      showOldTickets(){
        this.$store.dispatch('getOldTickets', {
          lead_id: this.chat.ticket.lead_id,
          per_page: 5
        })
      },
      openUrl(payload){
        window.open(payload, "_blank");
      },
      isRecording(){
        window.navigator.mediaDevices.getUserMedia({audio: true}).then(_stream => {
          this.stream = _stream;
          this.recorder = new MediaRecorder(_stream);
          this.recorder.ondataavailable = e => {
            if (this.recorder.state === 'inactive') this.makeBase64Recording(e.data);
          };
          this.recording = true
          this.recorder.start();
        }, e => {
          this.resetRecording();
        });
      },
      removeAudio(){
        this.recording = false
        this.recording_approval = false
        this.audioRecord = null
        this.audioRecordUrl = null
        setTimeout(() => {
          this.$refs.chatTextarea.focus()
        }, 200)
      },
      sendAudio(){
        this.recording = false
        this.recording_approval = false
        this.chat.ui.row_textarea = 1
        this.$store.dispatch('sendMessage', {
          file: this.audioRecord,
          text: "",
          channel_id: this.chat.ticket.channel_id,
          ticket_id: this.chat.ticket.id,
          operator_id: this.isOperator(this.chat.ticket.department_id),
          department_id: this.chat.ticket.department_id,
        })
        this.text = "";
        this.isShowEmoji = false;
        this.resetRecording()
        setTimeout(() => {
          this.$refs.chatTextarea.focus()
        }, 200)
      },
      stopRecording() {
        this.recorder.stop();
        this.stream.getAudioTracks()[0].stop();
        this.recording_approval = true;
      },
      makeBase64Recording(payload) {
        this.audioRecordUrl = URL.createObjectURL(payload)
        let reader = new FileReader();
        reader.readAsDataURL(payload);
        reader.onloadend = () => {
          this.audioRecord = reader.result/*.replace("audio/webm;codecs=opus", "audio/mp3")*/;
        };
        setTimeout(() => {
          this.resetRecording();
        }, 200);
      },
      resetRecording() {
        this.recorder = [];
        this.stream = [];
        this.chunks = [];
      },
      changeStatusTicket(){
        this.chat.ticket.status_key = this.chat.ticket.status_key === 4 ? 3 : 4
        this.updateTicket(this.chat.ticket)
      },
      changeFunnelTicket(payload){
        this.chat.ticket.funnel_id = payload.id === this.chat.ticket.funnel_id ? null : payload.id
        this.updateTicket(this.chat.ticket)
      },
      changeShowReplies(payload) {
        this.isShowReplies = payload
        if(this.isShowReplies){
          this.isShowEmoji = false
        }
        setTimeout(() => {
          document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
        }, 300);
      },
      sendReply(payload) {
        this.chat.ui.row_textarea = 1
        this.$store.dispatch('sendMessage', {
          text: payload.text,
          file: payload.file,
          file_original: true, // Necessário para validação no backend quando o arquivo já foi salvo no banco anteriormente.
          channel_id: this.chat.ticket.channel_id,
          ticket_id: this.chat.ticket.id,
          operator_id: this.isOperator(this.chat.ticket.department_id),
          department_id: this.chat.ticket.department_id,
        })
        this.text = "";
        this.isShowEmoji = false;
        this.isShowReplies = false;
      },
      getLeadVoip(payload){
        this.me.voip.lead = this.xeroxHelper(payload)
      }
    },
  }
  </script>
  
  <style src="../../assets/css/pages/chat.css" scoped/>
  
  <style lang="scss">
  .audio::-webkit-media-controls-enclosure {
    border-radius: 0;
    background-color: transparent;
  }
  
  .custom-picker-emoji {
    //position: absolute;
    min-width: 100%;
    //margin-left: -16px;
    max-height: 195px;
    //top: 537px;
    border-radius: 0 !important;
  }
  
  #Categories {
    position: absolute;
    //min-width: 99%;
    max-width: 98.8%;
  }
  #Emojis {
    top: 35px;
    //position: relative;
  }
  .container-emoji {
    padding-top: 35px;
    padding-bottom: 35px;
    height: 195px!important;
  }
  #EmojiPicker {
    display: block;
  }
  </style>
  
  <style scoped>
  .step .step-item {
    max-width: 100% !important;
  }
  .done_hover {
  }
  .done_hover:hover, .done_active {
    background: #64c400;
    color: #fff;
    border: 1px solid #64c400;
  }
  .fail_hover {
  }
  .fail_hover:hover, .fail_active {
    background: #e74a3b;
    color: #fff;
    border: 1px solid #e74a3b;
  }
  
  .replies {
  
  }
  .replies:hover {
    background: #e8e8e8;
  }
  </style>
  